import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "../lib/api";
import { useAuth } from "../lib/AuthContext";
import { Sparkles } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const r = await exchangeSession(sessionId);
        setUser(r.user);
        // Clean hash
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: r.user } });
      } catch (e) {
        navigate("/login?error=auth", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#050505] text-white grid place-items-center">
      <div className="flex items-center gap-3 text-zinc-300">
        <Sparkles className="h-5 w-5 text-[#00F2FE] animate-pulse" />
        <span className="font-body">Signing you in…</span>
      </div>
    </div>
  );
}
